// auth-service 权限管理相关接口（岗位/角色/数据权限）
import request from '../request'

// ===================== 岗位管理 =====================

// 查询所有岗位
export function fetchPositionList() {
    return request({
        url: '/auth-service/permission/position/list',
    })
}

// 新增岗位
export function addPosition(data) {
    return request({
        url: '/auth-service/permission/position/add',
        method: 'post',
        data,
    })
}

// 修改岗位
export function updatePosition(data) {
    return request({
        url: '/auth-service/permission/position/update',
        method: 'post',
        data,
    })
}

// 删除岗位（逻辑删除）
export function deletePosition(id) {
    return request({
        url: '/auth-service/permission/position/delete/' + id,
        method: 'post',
    })
}

// ===================== 岗位-角色绑定 =====================

// 按岗位查询绑定的角色列表（含角色编码/名称）
export function fetchPositionRoles(positionId) {
    return request({
        url: '/auth-service/permission/position/role/detail/' + positionId,
    })
}

// 批量设置岗位绑定的角色（全量覆盖）
export function updatePositionRoles(data) {
    return request({
        url: '/auth-service/permission/position/role/update',
        method: 'post',
        data,
    })
}

// ===================== 岗位-用户 =====================

// 按岗位查询拥有该岗位的用户列表（生效中）
export function fetchPositionUsers(positionId) {
    return request({
        url: '/auth-service/permission/position/users/' + positionId,
    })
}

// 给用户分配岗位
export function assignUserPosition(data) {
    return request({
        url: '/auth-service/permission/position/user/assign',
        method: 'post',
        data,
    })
}

// 移除用户岗位（逻辑删除）
export function removeUserPosition(data) {
    return request({
        url: '/auth-service/permission/position/user/remove',
        method: 'post',
        data,
    })
}

// 按用户查询生效中的岗位列表
export function fetchUserPositions(userId) {
    return request({
        url: '/auth-service/permission/position/user/positions/' + userId,
    })
}

// 按用户查询岗位、角色及功能权限全景（用户->岗位->角色->权限）
export function fetchUserAllPerms(userId) {
    return request({
        url: '/auth-service/permission/position/user/perms/' + userId,
    })
}

// ===================== 岗位-数据权限配置 =====================

// 查询岗位数据权限配置
export function fetchPositionDataPerms(positionId) {
    return request({
        url: '/auth-service/permission/position/data-permission/list/' + positionId,
    })
}

// 添加岗位数据权限
export function addPositionDataPerm(data) {
    return request({
        url: '/auth-service/permission/position/data-permission/add',
        method: 'post',
        data,
    })
}

// 删除岗位数据权限
export function deletePositionDataPerm(id) {
    return request({
        url: '/auth-service/permission/position/data-permission/delete/' + id,
        method: 'post',
    })
}

// ===================== 数据权限定义（tb_data_permission） =====================

// 查询全部数据权限定义
export function fetchDataPermissionList() {
    return request({
        url: '/auth-service/data-permission/list',
    })
}

// 新增数据权限定义
export function addDataPermission(data) {
    return request({
        url: '/auth-service/data-permission/add',
        method: 'post',
        data,
    })
}

// 修改数据权限定义
export function updateDataPermission(data) {
    return request({
        url: '/auth-service/data-permission/update',
        method: 'post',
        data,
    })
}

// 删除数据权限定义（逻辑删除）
export function deleteDataPermission(id) {
    return request({
        url: '/auth-service/data-permission/delete/' + id,
        method: 'post',
    })
}

// ===================== 用户特殊数据权限（tb_user_data_permission） =====================

// 查询用户特殊数据权限（传userId查单个用户，不传查全部）
export function fetchUserDataPerms(params) {
    return request({
        url: '/auth-service/data-permission/user/list',
        params,
    })
}

// 授予用户特殊数据权限（重复授予同code为续期/改值）
export function grantUserDataPerm(data) {
    return request({
        url: '/auth-service/data-permission/user/grant',
        method: 'post',
        data,
    })
}

// 回收用户特殊数据权限（按记录id）
export function revokeUserDataPerm(id) {
    return request({
        url: '/auth-service/data-permission/user/revoke/' + id,
        method: 'post',
    })
}

// ===================== 数据权限SQL测试 =====================

// 测试生成数据权限SQL（指定用户+业务表）
export function testDataPermissionSql(params) {
    return request({
        url: '/auth-service/data-permission/test',
        params,
    })
}

// ===================== 角色列表（auth-service） =====================

// 分页查询角色（岗位绑定角色对话框用）
export function fetchAuthRoleList(params) {
    return request({
        url: '/auth-service/role/list',
        params,
    })
}

// ===================== 审批流配置（review_task_category + tb_dict_review） =====================

// 审批类型列表（解析extra中的is_workflow/is_top）
export function fetchReviewCategoryList() {
    return request({
        url: '/auth-service/review-config/category/list',
    })
}

// 新增审批类型
export function addReviewCategory(data) {
    return request({
        url: '/auth-service/review-config/category/add',
        method: 'post',
        data,
    })
}

// 修改审批类型
export function updateReviewCategory(data) {
    return request({
        url: '/auth-service/review-config/category/update',
        method: 'post',
        data,
    })
}

// 删除审批类型（软删除：置 status=false，可恢复）
export function deleteReviewCategory(id) {
    return request({
        url: '/auth-service/review-config/category/delete/' + id,
        method: 'post',
    })
}

// 恢复审批类型（status 置回 true）
export function enableReviewCategory(id) {
    return request({
        url: '/auth-service/review-config/category/enable/' + id,
        method: 'post',
    })
}

// 新增审批节点变量
export function addReviewDict(data) {
    return request({
        url: '/auth-service/review-config/dict/add',
        method: 'post',
        data,
    })
}

// 删除审批节点变量（软删除，已绑岗位须先解绑）
export function deleteReviewDict(id) {
    return request({
        url: '/auth-service/review-config/dict/delete/' + id,
        method: 'post',
    })
}

// 更新审批类型extra（is_workflow/is_top开关）
export function updateReviewCategoryExtra(data) {
    return request({
        url: '/auth-service/review-config/category/extra',
        method: 'post',
        data,
    })
}

// 审批节点变量列表（type可选，含绑定岗位有效人数）
export function fetchReviewDictList(params) {
    return request({
        url: '/auth-service/review-config/dict/list',
        params,
    })
}

// 审批节点变量绑定岗位
export function bindReviewDictPosition(data) {
    return request({
        url: '/auth-service/review-config/dict/bind-position',
        method: 'post',
        data,
    })
}

// 审批节点变量解绑岗位
export function unbindReviewDictPosition(data) {
    return request({
        url: '/auth-service/review-config/dict/unbind-position',
        method: 'post',
        data,
    })
}

// 编辑直配人员/知会人员（老模式）
export function updateReviewDictUsers(data) {
    return request({
        url: '/auth-service/review-config/dict/update-users',
        method: 'post',
        data,
    })
}

// 批量查询岗位有效人员（审批节点绑定后预览人员）
export function fetchPositionUsersBatch(params) {
    return request({
        url: '/auth-service/review-config/position/users/batch',
        params,
    })
}
